const initialState = {
  list: {
    isLoading: false,
    error: '',
    data: [],
  },
  update: {
    isLoading: false,
    error: '',
  },
  add: {
    isLoading: false,
    error: '',
  },
  duplicate: {
    isLoading: false,
    isOpen: false,
    error: '',
    data: { targetId: '', targetName: '' },
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  info: {
    isLoading: false,
    error: '',
    data: {},
  },
};

export default initialState;
